// extracted by mini-css-extract-plugin
export var urlCopy = "url-copy-button-module--url-copy--nqlnx";
export var urlCopyButton = "url-copy-button-module--url-copy-button--wg15p";
export var urlCopyIcon = "url-copy-button-module--url-copy-icon--3rRsj";
export var urlCopyText = "url-copy-button-module--url-copy-text--2gs8I";
export var urlCopyResult = "url-copy-button-module--url-copy-result--31yNw";
export var urlCopyResultContainer = "url-copy-button-module--url-copy-result-container--Wxu34";